import { useMemo, useState } from "react";
import TerciaryButton from "@/components/buttons/terciary-button/TerciaryButton";
import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import InputSelect from "@/components/input-select/InputSelect";
import { PUESTO_OPTIONS } from "@/constants/selectsLists";
import { literals } from "@/constants/literals";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";

type RequestFilters = {
  area: string;
};

const RequestsFiltersMobile = ({
  initialFilters,
  onApply,
  onClose,
}: {
  initialFilters: RequestFilters;
  onApply: (filters: RequestFilters) => void;
  onClose: () => void;
}) => {
  const [areaForSelect, setAreaForSelect] = useState(
    initialFilters.area || "all",
  );

  const areaOptions = useMemo(() => {
    const filtered = PUESTO_OPTIONS.filter((option) => option.value !== "");
    return [{ label: literals.all, value: "all" }, ...filtered];
  }, []);

  const handleReset = () => {
    setAreaForSelect("all");
  };

  const handleApply = () => {
    onApply({
      area: areaForSelect === "all" ? "" : areaForSelect,
    });
  };

  return (
    <div className="pb-4">
      <div className="bg-[#EEEEEE] -mx-4 -mt-4 flex fixed w-full z-10">
        <TerciaryButton
          onClick={onClose}
          icon="arrowLeft"
          size="small"
          label={literals.goBackList}
          colour="red"
        />
      </div>

      <div className="grid gap-6 py-8">
        <h1 className="text-xl">{literals.filterRequests}</h1>

        <div className="grid gap-2">
          <InputSelect
            size="small"
            label={literals.workstation}
            id="requests-mobile-area"
            name="requests-mobile-area"
            options={areaOptions}
            value={areaForSelect}
            onChange={setAreaForSelect}
            placeholder={literals.workstation}
          />
        </div>

        <div className="grid gap-3 mt-4">
          <PrimaryButton
            size="medium"
            label={literals.applyFilters}
            colour="red"
            type="button"
            onClick={handleApply}
          />

          <SecondaryButton
            size="medium"
            label={literals.clearFilters}
            colour="red"
            buttonType="button"
            onClick={handleReset}
          />
        </div>
      </div>
    </div>
  );
};

export default RequestsFiltersMobile;
